import request from '@/libs/request';

export const getUploadSignApi = (data) => request('GetUploadSign', data);

export const getPrivateUploadSignApi = (data) => request('GetPrivateUploadSign', data);

export const GetRosterTemplate = (data) => request('GetRosterTemplate', data); // 下载导入模版
